import { useParams } from "react-router-dom";
import { DataAccumulatorForSingleOrderProvider } from "../../context/dataAccumulatorForSingleOrder";
import SubmissionStatusMain from "./components/submissionStatusMain/submissionStatusMain";

/**
 * Route entry for the submission status screen. Provides the page chrome
 * (gray background + padding), wraps the screen in the Postgres data-accumulator
 * provider, and delegates content to {@link SubmissionStatusMain}.
 *
 * @returns The submission status page.
 */
const SubmissionStatus = () => {
  const { id } = useParams();

  return (
    <div className="submission-info__main-container flex h-full w-full flex-col overflow-hidden">
      <DataAccumulatorForSingleOrderProvider>
        <SubmissionStatusMain id={id ?? ""} />
      </DataAccumulatorForSingleOrderProvider>
    </div>
  );
};

export default SubmissionStatus;
